// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1ut8B","filesListContainer":"PosDisputesFiles_filesListContainer__32FO3","filesButton":"PosDisputesFiles_filesButton__3nHrI"};